export const TOKEN_KEY = "maxUser";
export const PROFILE_USERTYPE = "admin";
